export default __webpack_public_path__ + "static/media/favicon.4bb896c1.ico";